import { Component } from '@angular/core';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css'],
  standalone: false
})
export class InvoicesComponent {

  columnNames = [
    {
      property: 'job_id',
      visible: false,
      displayName: 'Job ID'
    },
    {
      property: 'job_number',
      displayName: 'Job Number'
    },
    {
      property: 'job_type',
      displayName: 'Job Type'
    },
    {
      property: 'asset',
      displayName: 'Asset'
    },
    {
      property: 'due_date',
      displayName: 'Job Due Date'
    },
    {
      property: 'status',
      displayName: 'Status'
    },
    {
      property: 'mme_so',
      displayName: 'MME SO'
    }
  ];
  getRandomElement(arr:any) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
  generateRandomJob(index:any) {
    const locations = ['ABC Corp', 'XYZ Inc', 'LMN Services', 'DEF Ltd', 'GHI Group'];
    const descriptions = ['Install new software', 'Routine maintenance', 'Hardware upgrade', 'System analysis', 'Network setup'];
    const jobTypes = ['Installation', 'Maintenance', 'Upgrade', 'Analysis', 'Setup'];
    const statuses = ['Pending', 'Completed', 'In Progress', 'Delayed', 'Cancelled'];

    return {
      assets_number: (1000 + index).toString(),
      location: this.getRandomElement(locations),
      description: this.getRandomElement(descriptions),
      assets_type: this.getRandomElement(jobTypes),
      amount: `${(Math.random() * 1000 + 200).toFixed(2)}`,
      status: this.getRandomElement(statuses)
    };
  }
  jobs = Array.from({ length: 100 }, (_, index) => this.generateRandomJob(index));
}
